import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { container } from "tsyringe";
import { AnalyticsService } from "../../services/analytics";

export interface UuidGeneratorState {
  numberOfUuids: number;
  generatedUuids: string[];
  isGenerating: boolean;
}

const initialState: UuidGeneratorState = {
  numberOfUuids: 1,
  generatedUuids: [],
  isGenerating: false,
};

export const UuidGeneratorSlice = createSlice({
  name: 'uuidGenerator',
  initialState,
  reducers: {
    numberOfUuidsChanged: (state, action: PayloadAction<number>) => {
      state.numberOfUuids = action.payload;
    },
    clearGeneratedUuids: (state) => {
      state.generatedUuids = [];
    },
    setGeneratingState: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(generateUuidsAsync.fulfilled, (state, action) => {
      state.generatedUuids = action.payload;
      state.isGenerating = false;
    });
    builder.addCase(generateUuidsAsync.pending, (state) => {
      state.isGenerating = true;
    });
    builder.addCase(generateUuidsAsync.rejected, (state) => {
      state.isGenerating = false;
    });
  },
});

export const generateUuidsAsync = createAsyncThunk<
  string[],
  void,
  { state: RootState }
>(
  "uuidGenerator/generateUuidsAsync",
  async (_, { getState }) => {
    const analyticsService = container.resolve(AnalyticsService);
    analyticsService.LogEvent({
      category: "Button Click",
      action: "Generate UUIDs",
      label: "UUID Generator",
    });

    const state = getState().uuidGenerator;
    const uuids: string[] = [];

    for (let i = 0; i < state.numberOfUuids; i++) {
      // Generate UUID v4
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
      });
      uuids.push(uuid);
    }

    return uuids;
  }
);

export const { numberOfUuidsChanged, clearGeneratedUuids, setGeneratingState } = UuidGeneratorSlice.actions;

export const selectState = (state: RootState) => state.uuidGenerator;

export default UuidGeneratorSlice.reducer;
